module.exports = __webpack_public_path__ + "media/images/estrela-borda-a4f65d7234d22a844c30113598492425.svg";